const RANGE_ERROR_TYPE = 'RangeError';
const CALL_STACK_EXCEEDED_MESSAGE = 'Maximum call stack size exceeded';
const ADD_EL_HOOK_FRAME = 'addEL_hook';
const TOP_ADD_EVENT_LISTENER_FRAME = 'top.addEventListener';
const MIN_RECURSION_FRAMES = 5;

type FrameLike = {
  filename?: string;
  function?: string;
  abs_path?: string;
};

type ExceptionLike = {
  type?: string;
  value?: string;
  stacktrace?: {
    frames?: FrameLike[];
  };
};

type RecursionEventLike = {
  exception?: {
    values?: ExceptionLike[];
  };
  breadcrumbs?: Array<{ message?: string }>;
};

const LIPS_SOURCE_PATTERNS = ['/_next/', '/src/', 'lips.org.uk'];

function isLipsSourcePath(frame: FrameLike): boolean {
  const path = `${frame.abs_path ?? ''} ${frame.filename ?? ''}`;
  return LIPS_SOURCE_PATTERNS.some((pattern) => path.includes(pattern));
}

export function isKnownInjectedAddEventListenerRecursion(
  event: unknown,
): boolean {
  if (event === null || typeof event !== 'object') {
    return false;
  }

  const candidate = event as RecursionEventLike;
  const exceptions = candidate.exception?.values;

  if (
    !exceptions?.some(
      (exception) =>
        exception.type === RANGE_ERROR_TYPE &&
        exception.value === CALL_STACK_EXCEEDED_MESSAGE,
    )
  ) {
    return false;
  }

  const frames = exceptions.flatMap(
    (exception) => exception.stacktrace?.frames ?? [],
  );

  const hasAddElHook = frames.some(
    (frame) => frame.function === ADD_EL_HOOK_FRAME,
  );
  if (!hasAddElHook) {
    return false;
  }

  const addEventListenerFrameCount = frames.filter(
    (frame) => frame.function === TOP_ADD_EVENT_LISTENER_FRAME,
  ).length;
  if (addEventListenerFrameCount < MIN_RECURSION_FRAMES) {
    return false;
  }

  return !frames.some(isLipsSourcePath);
}
